import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

/**
 * Request payload for {@link submitFaxFormQuestionaire}.
 *
 * Mirrors the backend `ProcessFaxSubmissionRequest` model. Tenant scope comes
 * from the bearer token (`get_current_facility_id_from_request`); the body does
 * not accept `org_id`.
 */
interface SubmitFaxFormQuestionaireProps {
  form_id: string;
  order_id: string;
}

/**
 * Submits the fax questionnaire to generate a filled PDF for the order.
 *
 * @param props - Form and order ids
 * @returns Parsed JSON response from the submit endpoint
 * @throws {Error} When the HTTP response is not OK
 */
export const submitFaxFormQuestionaire = async (
  props: SubmitFaxFormQuestionaireProps,
) => {
  const token = await getBearerToken();

  const response = await fetch(API_ENDPOINTS.SUBMIT_FAX_FORM_QUESTIONNAIRE, {
    method: "POST",
    body: JSON.stringify({
      form_id: props.form_id,
      order_id: props.order_id,
    }),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      `Request failed with status ${response.status}: ${errorData.message || response.statusText}`,
    );
  }

  return response.json();
};
